import { useState, useEffect } from "react";
import { useAuthContext } from "./hooks/useAuthContext";
import Dropdown from "./Dropdown";
import { checkResponse } from "./utils";
import { useLogout } from "./hooks/useLogout";
import { Button, Table, Spinner, Modal, Form } from "react-bootstrap";

export default function Dumstreck(props) {
  const [dumstreck, setDumstreck] = useState(props.dumstreck);
  const [showGiveDumstreckModal, setShowGiveDumstreckModal] = useState(false);
  const [showRemoveDumstreckModal, setShowRemoveDumstreckModal] = useState(false);
  const [comment, setComment] = useState('');
  const [updatedRowId, setUpdatedRowId] = useState(null);

  const { user } = useAuthContext();
  const { logout } = useLogout();

  const handleCloseGiveModal = () => {
    // reset comment when closing modal
    setComment('');
    setShowGiveDumstreckModal(false);
  }
  const handleShowGiveModal = () => setShowGiveDumstreckModal(true);

  const handleCloseRemoveModal = () => setShowRemoveDumstreckModal(false);
  const handleShowRemoveModal = () => setShowRemoveDumstreckModal(true);


  useEffect(() => {
    // Initialize the dumstreck state with the value of props.dumstreck when the component mounts
    setDumstreck(props.dumstreck);
  }, [props.dumstreck]);

  // handles the press of the button `Ge Dumstreck!`
  async function giveDumstreck() {

    const editedPerson = {
      position_number: props.positionNumber,
      value: props.count, //TODO: not a very nice way, perhaps change
      update_total: true,
      comment: comment,
    };

    // updates database
    await updateDumstreck(editedPerson);
    // reset comment when closing modal
    setShowGiveDumstreckModal(false);
    setComment('');

  }

  // function to handle removal of dumstreck
  async function removeDumstreck() {
    const editedPerson = {
      position_number: props.positionNumber,
      value: -1,
      update_total: false,
    };

    await updateDumstreck(editedPerson)
    setShowRemoveDumstreckModal(false);
  }

  // updates database with new dumstreck
  async function updateDumstreck(editedPerson) {
    // This will send a post request to update the data in the database.
    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/streck/update/dumstreck`, {
      method: "POST",
      body: JSON.stringify(editedPerson),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${user.token}`,
      },
    });


    if (!await checkResponse(response, logout)) return;
    const dumstreck = await response.json();
    setDumstreck(dumstreck);
    
    setUpdatedRowId(null);
    setTimeout(() => {
      setUpdatedRowId(props.positionNumber);
    }, 0);
  }



  async function onClickGive(e) {
    e.preventDefault();
    await giveDumstreck();
  }

  async function onClickRemove(e) {
    e.preventDefault();
    await removeDumstreck();
  }


  const keydownHandlerGiveModal = async (e) => {
    switch (e.key) {
      case 'Enter':
        e.preventDefault();
        await onClickGive(e);
        break;
      default:
    }
  };

  const keydownHandlerRemoveModal = async (e) => {
    switch (e.key) {
      case 'Enter':
        e.preventDefault();
        await onClickRemove(e);
        break;
      default:
    }
  };

  // TODO: perhaps unfocus button after press, to prevent several being given.
  useEffect(() => {
    if (showGiveDumstreckModal) {
      document.addEventListener('keydown', keydownHandlerGiveModal);
    }

    if (showRemoveDumstreckModal) {
      document.addEventListener('keydown', keydownHandlerRemoveModal);
    }

    return () => {
      document.removeEventListener('keydown', keydownHandlerGiveModal);
      document.removeEventListener('keydown', keydownHandlerRemoveModal);
    };
  },);

  const dumstreckRows = Object.entries(dumstreck).map(([_, value]) => (
    <tr key={value._id} className={updatedRowId === value.position_number ? 'flash' : ''}>
      <td>{value.position}</td>
      <td>{JSON.stringify(value.dumstreck)}</td>
      <td>{JSON.stringify(value.total_dumstreck)}</td>
    </tr>
  ));

  const dumstreckPosition = dumstreck[props.positionNumber]?.position;

  return (
    <>
      <div className="container">
        <div className="dumstreck-div">

          <h2 >Dumstreck</h2>
        </div>
        {
          props.loading || dumstreck.length === 0 ? (<div className="div-spinner">
            <Spinner animation="border" role="status" />
          </div>
          ) :

            (<Table striped bordered hover responsive="sm" variant={props.theme} >
              <thead>
                <tr className="same-col-widths">
                  <th>Post</th>
                  <th>Antal</th>
                  <th>Totalt</th>
                </tr>
              </thead>
              <tbody>
                {dumstreckRows}
              </tbody>
            </Table>
            )}

        {user.role === "admin" && (
          <>
            <Modal
              show={showGiveDumstreckModal}
              onHide={handleCloseGiveModal}
            >
              <Modal.Header closeButton>
                <Modal.Title>Ge dumstreck</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <p>Vill du verkligen ge {dumstreckPosition} {props.count} dumstreck?</p>
                <Form>
                  <Form.Group controlId="formInput">
                    <Form.Label>Kommentar:</Form.Label>
                    <Form.Control type="text" value={comment} onChange={(e) => setComment(e.target.value)} />
                    <Form.Text style={{ color: props.theme === 'dark' ? 'lightgray' : 'gray' }}>
                      Lägg till en kommentar om anledningen till dumstrecket/dumstrecken (om du vill).
                    </Form.Text>
                  </Form.Group>
                </Form>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={handleCloseGiveModal}>Stäng</Button>
                <Button variant="primary" onClick={onClickGive}>Ge {props.count} dumstreck!</Button>
              </Modal.Footer>

            </Modal>


            <Modal
              show={showRemoveDumstreckModal}
              onHide={handleCloseRemoveModal}
            >
              <Modal.Header closeButton>
                <Modal.Title>Avverka dumstreck</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <p>Vill du verkligen avverka ett dumstreck för {dumstreckPosition}?</p>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={handleCloseRemoveModal}>Stäng</Button>
                <Button variant="primary" onClick={onClickRemove}>Avverka ett dumstreck!</Button>
              </Modal.Footer>

            </Modal>
            <div className="dropdown-button-div">
              <Dropdown id="dumstreckDropdown"></Dropdown>
              <div className="button-div">

                <Button variant={props.theme === 'dark' ? 'secondary' : 'primary'} disabled={props.loading} className="mb-1 py-1" onClick={handleShowGiveModal}>Ge Dumstreck!</Button>
                <Button variant={props.theme === 'dark' ? 'secondary' : 'primary'} disabled={props.loading || dumstreck[props.positionNumber]?.dumstreck === 0} className="mb-1 py-1" onClick={handleShowRemoveModal}>Avverka Dumstreck!</Button>
              </div>
            </div>
          </>
        )}
      </div>

    </>
  );
}
